import { render, staticRenderFns } from "./Searchbox.vue?vue&type=template&id=512ad209"
import script from "./Searchbox.vue?vue&type=script&lang=js"
export * from "./Searchbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports